<div class="ng-option">
  <div style="display: flex; align-items: center">
    <span style="overflow: hidden; width: 100%; text-overflow: ellipsis">{{searchTerm}}</span>
    <i (click)="click()" style="float: right; cursor: pointer; font-size: 17px; color: #3F88C5" class="fa fa-plus"></i>
  </div>
</div>